/**
 * Page title + description for the Brief Templates list view. Shared so the
 * empty state can replicate the page header copy from a single source.
 */
import { briefTemplateLevelLabel, type BriefTemplateLevel } from '@/entities/brief-template';
import { i18n } from '@/shared/i18n';

// Functions, not consts: resolving at call time is what lets the copy follow a
// language change instead of freezing at import.
export const briefTemplatesPageTitle = (): string =>
  i18n.t('knowledge:knowledgeHub.briefTemplatesConstants.briefTemplates');

export const briefTemplatesPageDescription = (): string =>
  i18n.t('knowledge:knowledgeHub.briefTemplatesConstants.createAndManageYourBrief');

export type BriefTemplateLevelFilter = 'all' | BriefTemplateLevel;

/** `off` is apart from the publication status: an off template matches neither Draft nor Published. */
export type BriefTemplateStatusFilter = 'all' | 'draft' | 'published' | 'off';

export interface BriefTemplateFilterOption<T extends string> {
  value: T;
  label: string;
}

/** Ordered from the narrowest level to the widest, as the brief creation picker groups them. */
export const buildLevelFilterOptions =
  (): BriefTemplateFilterOption<BriefTemplateLevelFilter>[] => [
    { value: 'all', label: i18n.t('knowledge:knowledgeHub.briefTemplatesToolbar.allLevels') },
    { value: 'workspace', label: briefTemplateLevelLabel('workspace') },
    { value: 'organization', label: briefTemplateLevelLabel('organization') },
    { value: 'system', label: briefTemplateLevelLabel('system') },
  ];

export const buildStatusFilterOptions =
  (): BriefTemplateFilterOption<BriefTemplateStatusFilter>[] => [
    { value: 'all', label: i18n.t('knowledge:knowledgeHub.briefTemplatesToolbar.allStatuses') },
    { value: 'draft', label: i18n.t('knowledge:knowledgeHub.briefTemplatesToolbar.draft') },
    { value: 'published', label: i18n.t('knowledge:knowledgeHub.briefTemplatesToolbar.published') },
    { value: 'off', label: i18n.t('knowledge:knowledgeHub.briefTemplatesToolbar.off') },
  ];
